/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IdentityMelcoModelsCustomWarning,
    IdentityMelcoModelsCustomWarningFromJSON,
    IdentityMelcoModelsCustomWarningFromJSONTyped,
    IdentityMelcoModelsCustomWarningToJSON,
    IdentityMelcoModelsSerialNumberListItem,
    IdentityMelcoModelsSerialNumberListItemFromJSON,
    IdentityMelcoModelsSerialNumberListItemFromJSONTyped,
    IdentityMelcoModelsSerialNumberListItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem
 */
export interface IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    /**
     * 
     * @type {Array<IdentityMelcoModelsSerialNumberListItem>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    list: Array<IdentityMelcoModelsSerialNumberListItem>;
    /**
     * 
     * @type {Array<IdentityMelcoModelsCustomWarning>}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    warning_list?: Array<IdentityMelcoModelsCustomWarning> | null;
    /**
     * 
     * @type {number}
     * @memberof IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem
     */
    total: number;
}

export function IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSON(json: any): IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    return IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json, false);
}

export function IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'list': ((json['list'] as Array<any>).map(IdentityMelcoModelsSerialNumberListItemFromJSON)),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(IdentityMelcoModelsCustomWarningFromJSON)),
        'total': json['total'],
    };
}

export function IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItemToJSON(value?: IdentityMelcoModelsGenericList1MelcoModelsSerialNumberListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'list': ((value.list as Array<any>).map(IdentityMelcoModelsSerialNumberListItemToJSON)),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(IdentityMelcoModelsCustomWarningToJSON)),
        'total': value.total,
    };
}


